import api from './api.js'

/**
 * Organisation membership / invitation API (carfile-user /v1/me/*).
 * Mirrors the thin-service pattern used across carfile-web.
 */

/** Pending invitations addressed to the current user. */
export const getInvitations = () =>
  api.get('/v1/me/invitations').then((r) => r.data)

/** Accept a pending invitation; resolves to the resulting membership. */
export const acceptInvitation = (orgId) =>
  api.post(`/v1/me/invitations/${orgId}/accept`).then((r) => r.data)

/**
 * Decline a pending invitation (durable: deletes the PENDING row server-side).
 * 204 No Content; idempotent.
 */
export const declineInvitation = (orgId) =>
  api.delete(`/v1/me/invitations/${orgId}`).then((r) => r.data)

/** The current user's ACTIVE organisation memberships. */
export const getMemberships = () =>
  api.get('/v1/me/memberships').then((r) => r.data)
